import { IntegrationConfig, IntegrationType } from "@types";
import github from "../assets/github.png";
import jira from "../assets/jira.png";
import linear from "../assets/linear.png";
import slack from "../assets/slack.png";

export const INTEGRATIONS: Record<IntegrationType, IntegrationConfig> = {
  [IntegrationType.SLACK]: {
    id: IntegrationType.SLACK,
    name: "Slack",
    logo: slack,
    description:
      "Connect your workspace and Slack identity to start secure Formly agent runs from Slack.",
    status: "disconnected",
    isComingSoon: false,
    isEnabled: true,
    authModel: "provider_oauth",
    agentAccessMode: "notifications_only",
  },
  [IntegrationType.GITHUB]: {
    id: IntegrationType.GITHUB,
    name: "GitHub",
    logo: github,
    description:
      "Connect your GitHub account to let the assistant manage issues, pull requests, and code reviews.",
    status: "disconnected",
    isComingSoon: false,
    isEnabled: true,
    authModel: "provider_oauth",
    agentAccessMode: "agent_tools",
  },
  [IntegrationType.LINEAR]: {
    id: IntegrationType.LINEAR,
    name: "Linear",
    logo: linear,
    description:
      "Connect your Linear workspace to let the assistant create issues, update projects, and manage your workflow.",
    status: "disconnected",
    isComingSoon: false,
    isEnabled: true,
    authModel: "provider_oauth",
    agentAccessMode: "agent_tools",
  },
  [IntegrationType.JIRA]: {
    id: IntegrationType.JIRA,
    name: "Jira",
    logo: jira,
    description:
      "Connect your Atlassian account so the assistant can sync Jira issues and related workspace data.",
    status: "disconnected",
    isComingSoon: false,
    isEnabled: true,
    isBeta: true,
    authModel: "provider_oauth",
    agentAccessMode: "sync_only",
  },
};

export const getIntegrationConfig = (
  id: IntegrationType | string
): IntegrationConfig | null => {
  const normalizedId = id.toLowerCase() as IntegrationType;
  return INTEGRATIONS[normalizedId] || null;
};

export const getAllIntegrations = (): IntegrationConfig[] => {
  return Object.values(INTEGRATIONS);
};
